import styled from "styled-components";

export const Container = styled.div<{ $inviteBackgroundImage?: string }>`
	width: 100%;
	//height: 100%;
	background: #f1e2c9;
	display: flex;
	//justify-content: center;
	flex-direction: column;
	align-items: center;
	border-radius: 16px;
	box-sizing: border-box;
	padding: 3em 0.5em;
	position: relative;
	top: -1.3em;

	&.invite {
		background-image: url(${(props) => props.$inviteBackgroundImage});
		background-position: bottom;
		background-repeat: no-repeat;
		background-size: contain;
	}
`;

export const Text = styled.div`
	font-family: Baloo;
	-webkit-text-stroke-width: 0.12em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	color: #fff;
	filter: drop-shadow(0 0.049em 0 #000);
	font-style: normal;
	font-weight: 400;
`;

export const Title = styled(Text)`
	width: 100%;
	//height: 100%;
	font-size: 2.125em;
	line-height: 1em;
	color: #fbbd05;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 16px;
	position: relative;

	@media (min-width: 945px) {
		font-size: 3.25em;
	}

	&.invite {
		text-align: center;

		span {
			width: 80%;
		}
	}
`;

export const InfoButton = styled.div`
	position: absolute;
	right: 0.5em;
	top: 0.5em;
	cursor: pointer;
	z-index: 2;

	@media (max-width: 420px) {
		top: 1.8em;
	}
`;

export const Subtitle = styled.div`
	color: #333;
	text-align: center;
	font-family: Inter;
	font-size: 1em;
	font-style: normal;
	font-weight: 700;
	max-width: 20em;

	@media (min-width: 945px) {
		max-width: 100%;
		font-size: 1.25em;
	}

	&.invite {
		max-width: 80%;
	}
`;
